import axios from "axios";
import { header } from "../../services/getcookie";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
  headers: header(),
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      document.cookie = "mawalog=; path=/; domain=.mawalog.com";
      window.location.href = process.env.REACT_APP_ACCOUNTS_URL;
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
